import React, { useEffect, useRef, useState } from "react";
import styles from "./DashChat.module.css";
import Avatar from "@mui/material/Avatar";
import { useNavigate, useLocation } from "react-router-dom";

import { useUtil } from "../../../contexts/UtilContext";
import { toast } from "react-toastify";
import axios from "axios";
import { useSearchParams } from "react-router-dom";
// import { initializeApp } from "firebase/app";
import {
  // getFirestore,
  collection,
  query,
  where,
  onSnapshot,
  orderBy,
} from "firebase/firestore";
import { fireDB } from "../../../util/firebase";
import chatBg from "../../../assets/img/chat-bg.png";

function DashChat({
  targetUser,
  targetMessage,
  accessToken,
  userDetails,
  chatIdFromParams,
  targetUserIdFromParams,
}) {
  const messagesEndRef = useRef(null);
  const { showLoader, hideLoader } = useUtil();
  const tempChatId = "temp_chat_id";

  // console.log("targetUser prop: ", targetUser);

  const [chats, setChats] = useState([]);
  const [currentChatDocId, setCurrentChatDocId] = useState("");
  const [currentChatTargetUser, setCurrentChatTargetUser] = useState({});
  const [currentChatMessages, setCurrentChatMessages] = useState([]);
  const [initialTargetChatLoaded, setInitialTargetChatLoaded] = useState(false);
  const [currentChatId, setCurrentChatId] = useState("");
  const [chatsLoaded, setChatsLoaded] = useState(false);
  const [newMessage, setNewMessage] = useState("");
  const [currentChatLoaded, setCurrentChatLoaded] = useState(false);
  const [showSendMessageLoader, setShowSendMessageLoader] = useState(false);
  const [currentChatLoading, setCurrentChatLoading] = useState(false);
  const messagesContainerRef = useRef(null);

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (chatIdFromParams && chats.length > 0) {
      setCurrentChatDocId(chatIdFromParams);

      const matchedChat = chats.find((chat) => chat.id === chatIdFromParams);
      if (matchedChat) {
        const otherUser =
          matchedChat.participants.find((p) => p.user_id !== userDetails.id)
            ?.user || {};
        setTargetUser(otherUser);
      }

      // Clean up URL after using the chatId and targetUserId
      const params = new URLSearchParams(location.search);
      params.delete("chatId");
      params.delete("targetUserId");

      const queryString = params.toString();
      navigate(`/MyFirstLand?s${queryString ? `&${queryString}` : ""}`, {
        replace: true,
      });
    }
  }, [chatIdFromParams, chats, userDetails?.id]);

  // @TODO: implement tags later
  // @TODO: implement firestore listener

  // @see: order
  // fetch all chats from backend
  // check if any targetUser exists
  // if yes, load targetUser
  //    if targetUser already exists, select that
  //    else, create a new chat view
  // else, select the first chat as targetUser
  // load the chatMessages

  // useEffect(() => {
  //   messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  // }, [currentChatMessages]);

  useEffect(() => {
    if (messagesContainerRef.current) {
      messagesContainerRef.current.scrollTop =
        messagesContainerRef.current.scrollHeight;
    }
  }, [currentChatMessages]);

  function stringAvatar(name) {
    const initials = name
      ? name
          .trim()
          .split(/\s+/) // handles multiple spaces
          .map((n) => n[0]?.toUpperCase() || "")
          .join("")
      : "";

    return {
      children: initials,
      style: {
        backgroundColor: "#4b5563", // Default background color
        color: "#f9f9f9", // Text color
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "50%",
        width: "50px",
        height: "50px",
        fontSize: "18px",
        fontWeight: "bold",
      },
    };
  }

  const formatTimestamp = (timestamp) => {
    return timestamp?.toDate().toLocaleString() || "N/A";
  };

  const sendMessage = async () => {
    // console.log("message: ", newMessage);
    // console.log("currentChatId: ", currentChatDocId);
    var isNewChat = currentChatDocId === tempChatId ? true : false;

    if (!newMessage) {
      toast.error("Please type a message to send");
      return;
    }

    try {
      setShowSendMessageLoader(true);

      const requestData = {
        message: newMessage,
        chatId: currentChatDocId,
        isNewChat,
        targetId: targetUser?.id || null,
      };
      const response = await axios.post(
        `${import.meta.env.VITE_BACKEND_URL}/dash/chat/send-message`,
        requestData,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );

      if (response.status === 200 && response.data && response.data.success) {
        // receive the chat id
        // update the chats list if this is a new chat
        // @TODO, @see: should also be implemented in firebase listener
        // console.log("response.data: ", response.data);
        // console.log("message sent response: ", response.data);
        setCurrentChatDocId(response.data.chatId);
        setNewMessage("");
      }
    } catch (error) {
      console.error("Error sedning message ", error);
    } finally {
      setShowSendMessageLoader(false);
    }
  };

  const handleMessageInputChange = (e) => {
    const { name, value } = e.target;
    setNewMessage(value);
  };

  // const onMessagesUpdate = (messages) => {
  //   console.log("chat messages to be processed: ", messages);
  //   setCurrentChatMessages(messages);
  // };

  const selectConversation = (chatDocId) => {
    // console.log("selected: ", chatDocId);
    if (!chatDocId) {
      console.error("Chat ID is required to listen to messages.");
      return;
    }

    setCurrentChatDocId(chatDocId);
  };

  const fetchAllUsersDetails = async (userIds) => {
    try {
      // console.log("all involved userIds: ", userIds);
      // @TODO: make API call here
      const requestData = {
        userIds: userIds,
      };
      const response = await axios.post(
        `${import.meta.env.VITE_BACKEND_URL}/dash/chat/fetch-users-details`,
        requestData,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );

      // console.log("chat users details response: ", response);
      if (
        response.status === 200 &&
        response.data &&
        response.data.success &&
        response.data.users
      ) {
        // console.log(
        //   "load the users details in the chats: ",
        //   response.data.users
        // );
        return response.data.users;
      }

      return false;
    } catch (error) {
      console.error("Error fetching user details: ", error);
      return false;
    }
  };

  const formatFirebaseTimestamp = (firebaseTimestamp) => {
    if (!firebaseTimestamp) return null;

    const timestamp = new Date(firebaseTimestamp.seconds * 1000); // Convert Firebase timestamp to JavaScript Date
    const today = new Date(); // Get the current date

    const isToday = timestamp.toDateString() === today.toDateString(); // Check if the date is today's date

    return isToday
      ? timestamp.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }) // Format as time if today
      : timestamp.toLocaleDateString(); // Format as date otherwise
  };

  useEffect(() => {
    let unsubscribeFn;

    const listenToChatMessages = (chatId) => {
      if (chatId === tempChatId) {
        setCurrentChatMessages([]);
        setCurrentChatTargetUser(targetUser || {});
        setNewMessage(targetMessage || "");
        return () => {}; // noop
      }

      const messagesRef = collection(fireDB, "chats", chatId, "messages");
      const messagesQuery = query(messagesRef, orderBy("sent_at"));

      return onSnapshot(
        messagesQuery,
        (snapshot) => {
          const liveMessages = snapshot.docs.map((doc) => ({
            ...doc.data(),
            docId: doc.id,
          }));
          setCurrentChatMessages(liveMessages);

          const chatData = chats.find((chat) => chat.docId === chatId);
          if (chatData && chatData.userDetails) {
            const targetUserData = chatData.userDetails.find(
              (user) => user.id !== userDetails.id
            );
            if (targetUserData) {
              setCurrentChatTargetUser(targetUserData);
            }
          }
        },
        (error) => {
          console.error("Error listening to messages:", error);
        }
      );
    };

    if (currentChatDocId) {
      setCurrentChatLoading(true);
      unsubscribeFn = listenToChatMessages(currentChatDocId);
      setCurrentChatLoading(false);
    }

    return () => {
      if (unsubscribeFn) unsubscribeFn();
    };
  }, [currentChatDocId]);

  useEffect(() => {
    const checkAndSetTargetChat = () => {
      if (chatIdFromParams) return;

      if (!targetUser?.id || !userDetails?.id) return;

      if (chats.length > 0) {
        const existingChat = chats.find(
          (chat) =>
            chat.users.length === 2 &&
            chat.users.includes(targetUser.id) &&
            chat.users.includes(userDetails.id)
        );

        if (existingChat) {
          setCurrentChatDocId(existingChat.docId);
          return;
        }
      }

      // If no chat found or chats still loading, fallback to tempChatId
      setCurrentChatDocId(tempChatId);
    };

    checkAndSetTargetChat(); // always try
  }, [targetUser, userDetails, chats]);

  // @TODO: fix this up for new target chats
  // useEffect(() => {
  //   // console.log("<<< 1");
  //   const checkAndSetTargetChat = (accessToken) => {
  //     if (targetUser && targetUser.id) {
  //       // console.log("<<< 3");
  //       // console.log("@@@ target user: ", targetUser);
  //       if (chats && chats.length) {
  //         // find if target user exists
  //         // else, create a new chat
  //         const targetChat = chats.find(
  //           (chat) =>
  //             chat.users.length == 2 &&
  //             chat.users.includes(targetUser.id) &&
  //             chat.users.includes(userDetails.id)
  //         );
  //         if (targetChat) {
  //           // target chat exists
  //           // console.log("@@@ target chat exists");
  //           // select the target chat
  //           selectConversation(targetChat.docId);
  //         } else {
  //           // create a new chat
  //           // console.log("@@@ create a new chat 1");
  //           setCurrentChatDocId(tempChatId);
  //         }
  //       } else {
  //         // create a new chat
  //         // console.log("@@@ create a new chat 2");
  //         setCurrentChatDocId(tempChatId);
  //       }
  //     } else {
  //       // @see: either set the first chat as the target or leave it like this
  //       // @TODO: for now, leave it like this
  //       // console.log("<<< 4");
  //     }
  //   };
  //   if (accessToken && chatsLoaded) {
  //     // fetchUserChats(accessToken);
  //     // console.log("<<< 2");
  //     checkAndSetTargetChat(accessToken);
  //   }

  //   return () => {};
  // }, [accessToken, chatsLoaded]);

  useEffect(() => {
    // console.log("userid: ", userDetails.id);

    const listenToFbChats = (userId) => {
      try {
        const chatsRef = collection(fireDB, "chats");
        const chatsQuery = query(
          chatsRef,
          where("users", "array-contains", userId)
        );

        // Listen to real-time updates
        const unsubscribe = onSnapshot(chatsQuery, (snapshot) => {
          // Define an async function to handle the snapshot
          const processSnapshot = async () => {
            let allUserIds = new Set();
            const liveChats = snapshot.docs.map((doc) => {
              const chatData = doc.data();
              if (chatData.users && Array.isArray(chatData.users)) {
                chatData.users.forEach((userId) => allUserIds.add(userId));
              }
              return { ...chatData, docId: doc.id };
            });

            // Convert the Set to an array
            const userIdsArray = Array.from(allUserIds);

            var tempChats = [];

            // Fetch user details asynchronously
            if (userIdsArray.length > 0) {
              try {
                const usersDetails = await fetchAllUsersDetails(userIdsArray);

                // Enrich the chats with user details
                const enrichedChats = liveChats.map((chat) => {
                  const chatUsers = chat.users.map(
                    (userId) =>
                      usersDetails.find((user) => user.id === userId) || {
                        id: userId,
                        name: "Unknown",
                      }
                  );
                  return { ...chat, userDetails: chatUsers };
                });

                // Sort chats by 'latest_message_sent_at' timestamp
                const orderedChats = enrichedChats.sort(
                  (a, b) =>
                    b.latest_message_sent_at.seconds -
                      a.latest_message_sent_at.seconds ||
                    b.latest_message_sent_at.nanoseconds -
                      a.latest_message_sent_at.nanoseconds
                );

                // console.log("orderedChats: ", orderedChats);

                // Update state with enriched chats
                tempChats = orderedChats;
              } catch (error) {
                console.error("Error fetching user details: ", error);
              }
            }

            setChats(tempChats);
            setChatsLoaded(true);
          };

          // Call the async function
          processSnapshot().catch((err) =>
            console.error("Error processing snapshot: ", err)
          );
        });

        // Return the unsubscribe function to stop listening when needed
        return unsubscribe;
      } catch (error) {
        console.error("Error setting up listener for chats: ", error);
      }
    };

    if (userDetails?.id) {
      // console.log("coming here 111?");
      listenToFbChats(userDetails.id);
    }

    return () => {};
  }, [userDetails?.id]);

  return (
    <div
      className={styles.chatContainer}
      style={{ backgroundImage: `url(${chatBg})` }}
    >
      <div className={styles.innerChatContainer}>
        <div className={styles.chatListsContainer}>
          {/* User profile section */}
          <div className={styles.userProfileContainer}>
            {userDetails && userDetails.photoUrl ? (
              <img
                src={userDetails.photoUrl}
                alt={`${userDetails.firstName} ${userDetails.lastName}`}
                className={styles.profileImage}
              />
            ) : (
              <Avatar alt="Remy Sharp" src="" />
            )}

            <span className={styles.profileName}>
              {userDetails.firstName} {userDetails.lastName}
            </span>
          </div>

          {/* List of chats */}
          <div>
            {chats && chats.length ? (
              chats.map((chat) => (
                <div
                  key={chat.docId}
                  onClick={() => selectConversation(chat.docId)}
                  className={`${styles.chatListCard} ${
                    chat.docId === currentChatDocId ? styles.chatSelected : ""
                  }`}
                >
                  {/* Chat user details */}
                  {chat.userDetails &&
                  chat.userDetails.filter((user) => user.id !== userDetails.id)
                    .length === 1 ? (
                    // Single user in the chat other than the current user
                    chat.userDetails
                      .filter((user) => user.id !== userDetails.id)
                      .map((otherUser) => (
                        <div
                          key={otherUser.id}
                          className={styles.chatListInnerCard}
                        >
                          <div className={styles.chatListUserPic}>
                            {otherUser.photo_url ? (
                              <img
                                src={otherUser.photo_url}
                                alt={`${otherUser.first_name} ${otherUser.last_name}`}
                                className={styles.userAvatar}
                                onError={(e) =>
                                  (e.target.style.display = "none")
                                }
                              />
                            ) : (
                              <Avatar
                                {...stringAvatar(
                                  `${otherUser.first_name} ${otherUser.last_name}`
                                )}
                              />
                            )}
                          </div>
                          <div className={styles.chatListUserDetails}>
                            <div className={styles.chatListUserName}>
                              {otherUser.first_name || "New User"}
                            </div>
                            <div className={styles.chatListMessage}>
                              {chat.latest_message || "No messages yet"}
                            </div>
                          </div>
                          <div className={styles.chatListTime}>
                            {chat.latest_message_sent_at
                              ? formatFirebaseTimestamp(
                                  chat.latest_message_sent_at
                                )
                              : null}
                          </div>
                        </div>
                      ))
                  ) : (
                    // Multiple users in the chat
                    <div className={styles.chatListInnerCard}>
                      <div className={styles.chatListUserPic}>
                        <img
                          src="default-group-avatar.png" // Default group picture
                          alt="Group"
                          className={styles.userAvatar}
                        />
                      </div>

                      <div className={styles.chatListUserDetails}>
                        <div className={styles.chatListUserName}>Group</div>
                        <div className={styles.chatListMessage}>
                          {chat.latest_message || "No messages yet"}
                        </div>
                      </div>
                      <div className={styles.chatListTime}>
                        {chat.latest_message_sent_at
                          ? formatFirebaseTimestamp(chat.latest_message_sent_at)
                          : null}
                      </div>
                    </div>
                  )}

                  {/* <div>{chat.docId}</div> */}
                  {/* <div>
                    {chat.latest_sender_id == userDetails.id
                      ? "sent"
                      : "received"}
                  </div> */}
                  {/* <div>
                    {chat.latest_message ? chat.latest_message : "null"}
                  </div> */}
                </div>
              ))
            ) : (
              <div>No chats</div>
            )}
          </div>
        </div>

        <div className={styles.chatMessagesContainer}>
          <div className={styles.chatMessagesTopContainer}>
            {currentChatTargetUser?.first_name ? (
              <div className={styles.chatDetails}>
                <div>
                  {currentChatTargetUser.photo_url ? (
                    <img
                      src={currentChatTargetUser.photo_url}
                      alt={`${currentChatTargetUser.first_name} ${currentChatTargetUser.last_name}`}
                      className={styles.userAvatar}
                      onError={(e) => (e.target.style.display = "none")}
                    />
                  ) : (
                    <Avatar
                      {...stringAvatar(
                        `${currentChatTargetUser.first_name} ${currentChatTargetUser.last_name}`
                      )}
                    />
                  )}
                </div>
                <div>{currentChatTargetUser.first_name}</div>
              </div>
            ) : (
              <div className={styles.chatDetails}>
                <span>No chat selected</span>
              </div>
            )}
            <div className={styles.chatActions}></div>
          </div>
          <div
            className={styles.chatMessagesMiddleContainer}
            ref={messagesContainerRef}
          >
            {currentChatMessages &&
              currentChatMessages.map((message) => {
                const isOwnMessage = message.sender_id === userDetails.id;
                const messageDate = new Date(
                  (message.sent_at?.seconds || 0) * 1000
                );
                const today = new Date();

                // Check if the message is from today
                const isToday =
                  messageDate.getDate() === today.getDate() &&
                  messageDate.getMonth() === today.getMonth() &&
                  messageDate.getFullYear() === today.getFullYear();

                return (
                  <div
                    key={message.docId}
                    className={
                      isOwnMessage ? styles.ownMessage : styles.otherMessage
                    }
                  >
                    <div className={styles.messageText}>{message.text}</div>
                    <div className={styles.messageTime}>
                      {isToday
                        ? messageDate.toLocaleTimeString([], {
                            hour: "2-digit",
                            minute: "2-digit",
                            hour12: true,
                          })
                        : messageDate.toLocaleDateString("en-US", {
                            month: "short",
                            day: "numeric",
                            year: "numeric",
                          }) +
                          " - " +
                          messageDate.toLocaleTimeString([], {
                            hour: "2-digit",
                            minute: "2-digit",
                            hour12: true,
                          })}
                    </div>
                  </div>
                );
              })}
            <div ref={messagesEndRef} />
          </div>
          <div className={styles.chatMessagesBottomContainer}>
            <input
              type="text"
              className={styles.messageInput}
              placeholder="Type a message..."
              value={newMessage}
              onChange={(e) => setNewMessage(e.target.value)}
            />
            <button
              className={styles.sendButton}
              onClick={sendMessage}
              disabled={!newMessage.trim()}
            >
              Send
            </button>
          </div>
          {/* {currentChatDocId ? (
            <div>
              {currentChatLoading ? (
                <div>Loader....</div>
              ) : (
                <div>
                  {currentChatDocId == tempChatId ? (
                    <div>
                      New Chat with target id - {targetUser.id}; name -{" "}
                      {targetUser.first_name}
                    </div>
                  ) : (
                    <div>
                      <div>Chat Doc Id - {currentChatDocId}</div>
                      <div>
                        {currentChatMessages &&
              currentChatMessages.map((message) => (
                <div
                  className={
                    message.senderId === userDetails.id
                      ? styles.ownMessage
                      : styles.otherMessage
                  }
                  key={message.docId}
                >
                  <div className={styles.messageText}>{message.docId}{message.text}</div>
                </div>
              ))}
          </div> */}
          {/* <div className={styles.messageList}>
            {currentChatMessages &&
              currentChatMessages.map((message) => (
                <div
                  className={
                    message.senderId === userDetails.id
                      ? styles.ownMessage
                      : styles.otherMessage
                  }
                  key={message.docId}
                >
                  <div className={styles.messageText}>{message.text}</div>
                </div>
              ))}
          </div> */}

          {/* Fixed input box and send button */}
          {/* <div className={styles.inputContainer}>
            <input
              type="text"
              className={styles.messageInput}
              placeholder="Type a message..."
              value={newMessage}
              onChange={(e) => setNewMessage(e.target.value)}
            />
            <button
              className={styles.sendButton}
              onClick={sendMessage}
              disabled={!newMessage.trim()}
            >
              Send
            </button>
          </div> */}
        </div>
      </div>
    </div>
  );
}

export default DashChat;
